/**
 * Breadcrumbs Component
 * @returns <Breadcrumbs />
 */

import { Link } from "react-router-dom";
import Button from "./Button";

const Breadcrumbs = ({ links, btnConfig }) => {

  return (
    <section className="breadcrumbs">
      <div className="wrapper">
        <div className="content">
          <ul>
            {links.map((link, i) => {
              return (
                <li key={i}>
                  <Link to={link.link} className="breadcrumbs__link">
                    {link.label}
                  </Link>
                </li>
              )
            })}
          </ul>

          {btnConfig && <Button {...btnConfig} />}
        </div>
      </div>
    </section>
  )
}

export default Breadcrumbs